
import React from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

const About = () => {
  // Team members
  const team = [
    {
      name: "Sarah Johnson",
      role: "Founder & CEO",
      bio: "Former Olympic coach with 15+ years of experience in sports management.",
      image: "https://i.pravatar.cc/300?u=a042581f4e29026704d"
    },
    {
      name: "David Chen",
      role: "CTO",
      bio: "Software engineer with a passion for creating tools that empower coaches.",
      image: "https://i.pravatar.cc/300?u=a042581f4e29026704e"
    },
    {
      name: "Maria Rodriguez",
      role: "Head of Customer Success",
      bio: "Helping coaches optimize their businesses through technology for over a decade.",
      image: "https://i.pravatar.cc/300?u=a042581f4e29026704f"
    },
    {
      name: "James Wilson",
      role: "Product Manager",
      bio: "Former gymnastics coach turned product expert, focused on user experience.",
      image: "https://i.pravatar.cc/300?u=a042581f4e29026704g"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 container py-8 mt-16">
        <div className="mb-12 max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-4">About ThePoppyApp</h1>
          <p className="text-xl text-muted-foreground">
            We're on a mission to simplify the business side of coaching, 
            so you can focus on what matters most—helping your clients succeed.
          </p>
        </div>
        
        <div className="grid gap-12">
          <section>
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <p className="mb-4">
                  ThePoppyApp was born out of frustration. Our founder, Sarah Johnson, was a successful Olympic-level coach 
                  who found herself spending more time on paperwork and scheduling than actually coaching.
                </p>
                <p className="mb-4">
                  In 2018, Sarah teamed up with tech expert David Chen to create a solution that would automate the 
                  administrative side of coaching businesses. What started as a simple scheduling tool has evolved into 
                  a comprehensive platform used by thousands of coaches worldwide.
                </p>
                <p>
                  Today, ThePoppyApp helps coaches in over 30 countries manage their schedules, track client progress, 
                  and grow their businesses—all while saving them an average of 10 hours per week in administrative tasks.
                </p>
              </div>
              <div className="bg-muted rounded-lg h-64 flex items-center justify-center">
                <p className="text-muted-foreground">Company timeline image</p>
              </div>
            </div>
          </section>
          
          <section>
            <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
            <Card className="bg-primary/5 border-none">
              <CardContent className="pt-6">
                <p className="text-xl italic">
                  "To empower coaches with technology that simplifies their business operations, 
                  so they can focus on their true passion—transforming lives through coaching."
                </p>
              </CardContent>
            </Card>
          </section>
          
          <section>
            <h2 className="text-3xl font-bold mb-6">Our Team</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {team.map((member) => (
                <Card key={member.name} className="text-center">
                  <CardContent className="pt-6">
                    <Avatar className="h-24 w-24 mx-auto mb-4">
                      <AvatarImage src={member.image} alt={member.name} />
                      <AvatarFallback>
                        {member.name.split(' ').map(n => n[0]).join('')}
                      </AvatarFallback>
                    </Avatar>
                    <h3 className="text-lg font-bold">{member.name}</h3>
                    <p className="text-primary font-medium mb-2">{member.role}</p>
                    <p className="text-muted-foreground text-sm">{member.bio}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </section>
          
          <section>
            <h2 className="text-3xl font-bold mb-6">Our Values</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                {
                  title: "Simplicity",
                  description: "We believe that technology should simplify life, not complicate it. Our platform is designed to be intuitive and easy to use."
                },
                {
                  title: "Empowerment",
                  description: "We create tools that empower coaches to take control of their businesses and achieve their goals."
                },
                {
                  title: "Continuous Improvement",
                  description: "Just like the coaches we serve, we're constantly learning, evolving, and improving our platform based on user feedback."
                }
              ].map((value) => (
                <Card key={value.title}>
                  <CardContent className="pt-6">
                    <h3 className="text-xl font-bold mb-2">{value.title}</h3>
                    <p className="text-muted-foreground">{value.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default About;
